var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"map mb-2"},[_c('units-map-slot',{attrs:{"mode":"drawing","data":_vm.mapData},on:{"circle-updated":_vm.onCircleUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }